function getEnvFromURL() {
	const hostName = window?.location?.hostname?.toLocaleLowerCase();
	if (hostName.includes('localhost') || hostName.includes('192.168.')) return 'development';
	else if (hostName.includes('nightly')) return 'nightly';
	else if (hostName.includes('staging')) return 'staging';
	else return 'production';
}

export { getEnvFromURL };
